/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState, useContext} from 'react';
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/analytics";
import {
  Switch,
  Route,
  useParams,
  useRouteMatch,
} from "react-router-dom";
import { uid } from 'uid';
import Character from './Character';
import Dm from './Dm';
import NewCharacterForm from '../components/NewCharacterForm';
import UserContext from '../context/UserContext';
import CampaignContext from '../context/CampaignContext';
import CharacterContext from '../context/CharacterContext';
import SystemContext from '../context/SystemContext';
import {SYSTEMS, isCampaignOfSystem} from '../utils/gameSystem';
import VtmCharacterPage from '../vtm/components/VtmCharacterPage';
import VtmDmPage from '../vtm/components/dm/VtmDmPage';
import VtmClaimPage from '../vtm/components/VtmClaimPage';
import {saveNewCharacter} from '../vtm/characterRepository';
import {createVtmCharacter} from '../vtm/character';
import {init} from '../utils/initFirebase'
import '../styles/characters.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import i18next from 'i18next';
import AriaCampaignHome from '../components/AriaCampaignHome';
import VtmCampaignHome from '../vtm/components/VtmCampaignHome';
import alchemy from '../assets/alchemy.json';
import {useHistory} from "react-router-dom";
import cards from '../assets/cards.json';
import Statistics from '../containers/Statistics';
import {isDesktop} from "react-device-detect";
import Modal from 'react-modal';

init();
const db = firebase.firestore();
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxHeight: isDesktop ?' 80%' : '80%',
    maxWidth: isDesktop ?' 50%' : '100%',
    boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
    borderRadius: '0.5rem'
  },
}
const Characters = (props) => {
  let match = useRouteMatch();
  const history = useHistory();
  let { campaignIdUrl } = useParams();
  const [characters, setCharacters] = useState([])
  const [charactersLoaded, setCharactersLoaded] = useState(false)
  const [character, setCharacter] = useState({
      name: '',
      uid: undefined,
      idCampaign: undefined,
      idUser: undefined,
      currentHp: undefined,
      maxHp: undefined,
      description: '',
      skills: [],
      characteristics: [],
  })
  const {user} = useContext(UserContext)
  const {campaign, updateCampaign} = useContext(CampaignContext)
  const gameSystem = useContext(SystemContext);
  const campaignIdUsed = campaign.uid || campaignIdUrl;
  const contextValue = { character, updateCharacter: setCharacter}
  const [modalIsOpen, setIsOpen] = React.useState(false);
  
  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  useEffect( () => {
    if(user.uid){
      getCampaign();
    }
  }, []);


  const getCharactersVisibleForUser = async (currentCampaign) => {
    try {
      const listCharacters = [];
      const listCharactersGroup = [];
      await db.collection('characters').where('idCampaign', '==', campaignIdUsed).where('active', '==', true).get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            if(doc.data().idUser === user.uid || currentCampaign.idUserDm === user.uid) {
              listCharacters.push(doc.data())
            }
            if(doc.data().idUser !== currentCampaign.idUserDm) {
              listCharactersGroup.push(doc.data())
            }
          });
          setCharacters(listCharacters);
          setCharactersLoaded(true);
        })
        .catch(err => {
          console.log(err.messsage)
        })
    } catch (error) {
      console.log(error);
    }
  }

  const getCampaign = async () => {
    await db.collection('campaigns').doc(campaignIdUsed).get()
    .then(doc => {
      if(!doc.exists || !isCampaignOfSystem(doc.data(), gameSystem)) {
        history.push('/campaigns');
        return;
      }
      updateCampaign(doc.data());
      getCharactersVisibleForUser(doc.data());
    })
    .catch(err => {
      console.log(err.messsage)
    })
  }

  const createCharacter = async (characterData) => {
    const characterUid = uid();
    const data = {
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      lastUpdateAt:firebase.firestore.FieldValue.serverTimestamp(),
      name: characterData.name,
      uid: characterUid,
      idCampaign: campaignIdUsed,
      idUser: user.uid,
      currentHp: characterData.hp,
      maxHp: characterData.hp,
      description: characterData.description,
      skills: [...characterData.skills],
      characteristics: [...characterData.characteristics],
      isAlchemist: characterData.isAlchemist,
      isMage: characterData.isMage,
      isDeathMage: characterData.isDeathMage,
      inventory: [],
      picture: null,
      active: true
    };
    if(characterData.isDeathMage) {
      data.skills.push({
        isCustom: false,
        label: "deathMagic",
        value: 0,
        isSpecial: true
      });
    }
    if(characterData.isAlchemist) {
      data.alchemy = alchemy;
      data.inventory.push({
        default: true,
        name: "karloff",
        number: 1,
        type: "alchemy"}
      )
      data.inventory.push({
        default: true,
        name: "ingramus",
        number: 1,
        type: "alchemy"}
      )
      data.inventory.push({
        default: true,
        name: "bottle",
        number: 3,
        type: "alchemy"}
      )
    }
    if(characterData.isMage) {
      data.magicCards = [...cards]
    }
    await db.collection('characters').doc(characterUid).set(data).then(res => {
      // const charactersList = getValueOnLocalStorage('characters');
      const charactersList = [...characters]
      charactersList.push(data);
      setCharacters(charactersList);
      // setValueOnLocalStorage('characters',charactersList);
      // getCharactersVisibleForUser(campaignIdUsed);

      firebase.analytics().logEvent('characterCreation',{
        characterName: data.name,
        characterIdUser: data.idUser,
        characterIdCampaign: data.idCampaign,
        characterUid: data.uid,
        characterIsAlchemist: characterData.isAlchemist,
      });
      toast.success(`${characterData.name} ${i18next.t('was created with success')}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setCharacter(data)
      history.push(`${match.url}/${characterUid}`);
    }).catch(e => {
      console.log(e)
    });
  }

  // Nouveau personnage VtM : un brouillon, complété ensuite dans l'assistant de création.
  const createVtmDraft = async () => {
    const data = createVtmCharacter({uid: uid(), idUser: user.uid, idCampaign: campaignIdUsed});
    try {
      await saveNewCharacter(data);
      setCharacters([...characters, data]);
      setCharacter(data);
      history.push(`${match.url}/${data.uid}`);
    } catch (e) {
      console.log(e);
    }
  }

  const isVtm = gameSystem === SYSTEMS.VTM5;

  if(user && campaign) {
    return (
      <div className='containerCharacters'>
        <CharacterContext.Provider value={contextValue}>
          <Switch>
            <Route path={`${match.url}/dm`} exact={true}>
              {isVtm ? <VtmDmPage /> : <Dm/>}
            </Route>
            <Route path={`${match.url}/statistics`} exact={true}>
              <Statistics/>
            </Route>
            {isVtm && (
              <Route path={`${match.url}/claim/:characterUid`} exact={true}>
                <VtmClaimPage />
              </Route>
            )}
            <Route path={`${match.url}/:characterIdUrl`}>
              {isVtm ? <VtmCharacterPage /> : <Character character={character}/>}
            </Route>
            <Route path={match.path}>
              {isVtm ? (
                <VtmCampaignHome
                  campaign={campaign}
                  characters={characters}
                  loading={!charactersLoaded || !campaign.uid}
                  userUid={user.uid}
                  baseUrl={match.url}
                  onSelectCharacter={setCharacter}
                  onCreateCharacter={createVtmDraft}
                />
              ) : (
                <AriaCampaignHome
                  campaign={campaign}
                  characters={characters}
                  loading={!charactersLoaded || !campaign.uid}
                  userUid={user.uid}
                  baseUrl={match.url}
                  onSelectCharacter={setCharacter}
                  onCreateCharacter={openModal}
                />
              )}

              <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                overlayClassName="Overlay"
                contentLabel="Example Modal"
              >
                <NewCharacterForm
                  className='newCharacterForm'
                  createCharacter={(character) => { createCharacter(character) }}
                />
              </Modal>
            </Route>
          </Switch>
        </CharacterContext.Provider>
      </div>
    );
  }
}

export default Characters